import React, { useState } from "react";
import { Button } from "@mui/material";
import DocumentModal from "./DocumentModal";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { DocumentButtonProps } from "../Utils/Types";

const DocumentButton = (props: DocumentButtonProps) => {
  const { buttonTitle, documentType, control, getValues, setValue, onDocumentSaved, allDocumentTypes, existingDocument } = props;
  const [openModal, setOpenModal] = useState(false);

  const handleClick = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <div>
      <Button
        startIcon={<CalendarMonthIcon />}
        size="small"
        variant="contained"
        onClick={handleClick}
      >
        {buttonTitle}
      </Button>
      {openModal && (
        <DocumentModal
          setValue={setValue}
          getValues={getValues}
          control={control}
          title={buttonTitle}
          documentType={documentType}
          onClose={handleClose}
          onDocumentSaved={onDocumentSaved}
          allDocumentTypes={allDocumentTypes}
          existingDocument={existingDocument}
        />
      )}
    </div>
  );
};

export default DocumentButton;
